var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.showFilter}},[_c('v-icon',[_vm._v("mdi-filter-outline")])],1),_c('filter-coach-dialog',{ref:"filter"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }